import {
  Dialog,
  DialogActionButton,
  DialogActions,
  DialogCancelButton,
  DialogContent,
  DialogDescription,
  DialogHeader,
  type DialogProps,
  Text,
} from "@prismicio/editor-ui"
import { useState } from "react"

import type { RepositoryLocale } from "../../app/services/locales"
import type { SetRepositoryLocaleAsMasterMutation } from "./useRepositoryLocales"

interface SetAsMasterDialogProps {
  repositoryLocale: RepositoryLocale
  setRepositoryLocaleAsMasterMutation: SetRepositoryLocaleAsMasterMutation
  trigger: DialogProps["trigger"]
}

export function SetAsMasterDialog(props: SetAsMasterDialogProps) {
  const { repositoryLocale, setRepositoryLocaleAsMasterMutation, trigger } =
    props

  const [open, setOpen] = useState(false)

  return (
    <Dialog onOpenChange={setOpen} open={open} size="small" trigger={trigger}>
      <DialogHeader title="Are you sure you want to change your master locale?" />
      <DialogDescription asChild>
        <DialogContent padding={16}>
          <Text>
            This will change the master locale for your repository. The API will
            return content in the new master locale by default.
          </Text>
        </DialogContent>
      </DialogDescription>
      <DialogActions>
        <DialogCancelButton />
        <DialogActionButton
          loading={setRepositoryLocaleAsMasterMutation.isPending}
          onClick={() => {
            setRepositoryLocaleAsMasterMutation.mutate(repositoryLocale, {
              onSuccess: () => {
                setOpen(false)
              },
            })
          }}
        >
          Confirm
        </DialogActionButton>
      </DialogActions>
    </Dialog>
  )
}
